// Copyright (c) Cosmo Tech.
// Licensed under the MIT license.

// Available Power BI actions
export const POWER_BI_ACTIONS_KEY = {
  SET_EMBED_INFO: 'SET_EMBED_INFO',
  SET_REPORTS_CONFIG: 'SET_REPORTS_CONFIG',
  GET_EMBED_INFO: 'GET_EMBED_INFO',
  CLEAR_EMBED_INFO: 'CLEAR_EMBED_INFO',
};

export const GET_EMBED_INFO_URL = '/api/get-embed-info';
